"use client"; // Error boundaries must be Client Components

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Report to New Relic if available
    console.error("error caught in login layout");
    console.error(error);
    if (typeof window !== "undefined" && (window as any).newrelic) {
      (window as any).newrelic.noticeError(error, {
        digest: error.digest,
        location: window.location.href,
      });
    }
  }, [error]);

  return (
    <div>
      <h2>Something went wrong!</h2>
      <button
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        Try again
      </button>
    </div>
  );
}
